import axios from 'axios';
import store from '@/store';

const request = axios.create({
    // baseURL: 'http://x75.pusite.icu/api',
    baseURL: 'http://x87.www.wuw.wang/api',
    timeout: 5000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
});

request.interceptors.request.use(function (config) {
    config.headers['Authorization'] = store.state.user.token;
    return config;
});

// if (request.name) {
// }

request.interceptors.response.use(
    response => {
        return response.data;
    },
    err => {
        const response = err.response;
        const data = response.data;
        return Promise.reject(data);
    }
);

export default request;
